// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .icon.copy[data-v-c745c34e]{display:inline-block;margin:-.25rem 0 0 0}#app label[data-v-c745c34e]{margin:0;padding:0}", ""]);
// Exports
module.exports = exports;
